import * as React from 'react';
import { overrideCSS } from '../../utils';
import { HistoricalPricesModal } from "../../components/HistoricalPricesModal/HistoricalPricesModal";
import { toggleModal } from "../../actions";
import { IAppParams, IDataEntity, IModals } from "../../models";
const FaDownload = require('react-icons/lib/fa/download');

const internalStyles = require('./HistoricalDownload.pcss');

interface IProps {
    styles?: string
    shareClass?: IDataEntity;
    appParams?: IAppParams;
    toggleModal?: typeof toggleModal;
    modals?: IModals;
}

export class HistoricalDownload extends React.Component<IProps, {}>{
    constructor(props) {
        super(props);
        this.state = {showModal: false};
    }

    handleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        
        this.props.toggleModal(this.props.shareClass);
    }

    render() {
        let styles = this.props.styles ? overrideCSS(internalStyles, this.props.styles) : internalStyles;
        let { shareClass, appParams } = this.props;
        let { language, clienttype, region } = appParams

        return (
            <div>
                <a href="" onClick={this.handleClick.bind(this)} className={styles.anchor}>
                    <FaDownload />
                </a>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/client/assets/HistoricalDownload/HistoricalDownload.tsx